function Logout() {
    localStorage.clear();
}
export default Logout
